import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getAccessToken } from "@/shared/infrastructure/auth/token-storage";
import { DoctorShell } from "@/app/layout/DoctorShell";

/**
 * Segmento de URL real ("/doctor"), não uma rota pathless como "_authenticated" —
 * um layout pathless aqui colidiria com o índice "/" do paciente.
 */
export const Route = createFileRoute("/doctor")({
  beforeLoad: () => {
    if (!getAccessToken()) {
      throw redirect({ to: "/doctor-login" });
    }
  },
  component: () => (
    <DoctorShell>
      <Outlet />
    </DoctorShell>
  ),
});
